import { Injectable } from "@angular/core";
import * as Sentry from "@sentry/angular";

@Injectable({
	providedIn: "root"
})
export class LoggingService {
	public logEvent(name: string, properties?: Record<string, unknown>): void {
		Sentry.logger.trace(name, properties);
	}

	public logException(exception: Error, context?: Record<string, unknown>): void {
		Sentry.withScope((scope) => {
			if (context !== undefined) {
				scope.setContext("details", context);
			}
			Sentry.captureException(exception);
		});
	}
}
